module.exports = __webpack_public_path__ + "static/media/Redtie-AI.0f1fc569.gif";